import { nodeAjax } from "./index";

const getUserInfo = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticSso/account/getUserInfo", option);
};
const getTotalNum = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticMember/order/getTotalNum", option);
};
const mergeTopbar = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticnode/portal/topbar", option);
};
const searchHotWord = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/search/hotWord", option);
};
const qryTitle = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/solrServer/content/qryTitle", option);
};
const qryNavi = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticMall/navi/qry", option);
};
const logout = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticSso/account/logout", option);
};
/* 查询常见问题 */
const qryKnowledge = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticMall/knowledge/qryKnowledge", option);
};
/* 热门资讯&技术文章 新的case列表 */
// const qryCaseList = (data, apiHost, option) => {
//   return nodeAjax(data, apiHost + "/ticMall/cases/qryCaseList", option);
// };
/* 资讯列表 原有的列表 */
const qryCase = (data, apiHost, option) => {
  data.belongBu = localStorage.getItem("bu");
  return nodeAjax(data, apiHost + "/ticMall/cases/qryCase", option);
};
/* 资讯列表 分类 */
const qryCategory = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticNode/category/qry", option);
};
// 资讯详情
const qryCaseDtl = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/case/detail", option);
};
// 资讯详情 - 获取案例相关接口
const caseRecommend = (data, apiHost, option) => {
  data.belongBu = localStorage.getItem("bu");
  return nodeAjax(data, apiHost + "/case/recommend", option);
};
// 资讯详情 - 点赞、取消点赞
const likeSet = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticMember/like/set", option);
};
// 资讯详情 - 获取点赞情况
const likeStat = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticMember/like/stat", option);
};
// 资讯详情 - 获取点赞数量
const likeStatNumber = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/bigdata/statByBusi/number", option);
};
// 提交工单 - 查询城市
const qryCity = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticCenter/org/qryCity", option);
};
// 提交工单 - 获取验证码
const getCode = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticCenter/verify/getCode", option);
};
// 提交工单 - 通过手机号创建工单
const createTicketByPhone = (data, apiHost, option) => {
  return nodeAjax(data, apiHost + "/ticMall/ticket/createByVerify", option);
};

export function qryProduct(data, apiHost, option) {
  return nodeAjax(data, apiHost + '/ticMall/product/qry', option)
}

export function qryByAlias(data, apiHost, option) {
  return nodeAjax(data, apiHost + '/ticMall/catalog/qryByAlias', option)
}


export {
  getUserInfo,
  getTotalNum,
  mergeTopbar,
  logout,
  searchHotWord,
  qryTitle,
  qryNavi,
  qryKnowledge,
  // qryCaseList,
  qryCase,
  qryCaseDtl,
  caseRecommend,
  likeSet,
  likeStat,
  likeStatNumber,
  qryCategory,
  qryCity,
  getCode,
  createTicketByPhone
};
